import React, { Fragment } from "react";
import { Cell, Pie, PieChart, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { H6, P } from "../../atoms/Texts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

const SSNPieChart = ({ data, height, paddingAngle, colorScheme }) => {
  return data?.length > 0 ? (
    <ResponsiveContainer width="100%" height={height || "100%"}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={40}
          outerRadius={80}
          fill="#8884d8"
          paddingAngle={paddingAngle ?? 0}
          label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
          dataKey="value"
        >
          {data?.map((entry, index) => (
            <Fragment key={index}>
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            </Fragment>
          ))}
        </Pie>
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  ) : (
    <>
      <H6>No data for this metric</H6>
      <P fontSize="14px">
        We are still tracking impact for this. At the moment there is none.
      </P>
    </>
  );
};

export default SSNPieChart;
